import { type EmojiId, type OptIn, type OptInType, type UserAccount } from '@app/client';
import { type User } from '@app/helpers';

export const ACTION_SET_USER = 'ACTION_SET_USER';
export const ACTION_REMOVE_USER = 'ACTION_REMOVE_USER';
export const ACTION_CLEAR_USER_DATA = 'ACTION_CLEAR_USER_DATA';
const ACTION_SET_SYNCED_WALLETS = 'ACTION_SET_SYNCED_WALLETS';
export const ACTION_SET_USER_PRIMARY_YAT = 'ACTION_SET_USER_PRIMARY_YAT';
export const ACTION_SET_SKIP_PRIMARY_YAT_FLOW = 'ACTION_SET_SKIP_PRIMARY_YAT_FLOW';
export const ACTION_SET_USER_OPT_INS = 'ACTION_SET_USER_OPT_INS';
export const ACTION_SET_USER_OPT_IN = 'ACTION_SET_USER_OPT_IN';

export const USER_ROLE_ADMIN = 'Admin';
export const USER_ROLE_SUPER = 'Super';

interface SetUserAction {
    type: typeof ACTION_SET_USER;
    user: UserAccount;
}

interface RemoveUserAction {
    type: typeof ACTION_REMOVE_USER;
}

type SyncedWallets = string[] | null;

export type WalletItem = NonNullable<SyncedWallets>[number];
export type WalletReadonly = ReadonlyArray<WalletItem>;

interface SetSyncedWalletAction {
    type: typeof ACTION_SET_SYNCED_WALLETS;
    syncedWallets: SyncedWallets;
}

export type UserState = {
    isRegisteredUser: boolean;
    isVerifiedUser: boolean | undefined;
    primaryYat: EmojiId | undefined;
    skipPrimaryYatFlow: boolean;
    userClass?: User;
    userAccount?: UserAccount;
    optIns: OptIn[];
};

interface SetUserPrimaryYatAction {
    type: typeof ACTION_SET_USER_PRIMARY_YAT;
    primaryYat: EmojiId | undefined;
}

interface SetUserSkipPrimaryYatFlowAction {
    type: typeof ACTION_SET_SKIP_PRIMARY_YAT_FLOW;
    skip: boolean;
}

interface SetUserOptinsAction {
    type: typeof ACTION_SET_USER_OPT_INS;
    optIns: OptIn[];
}

interface SetUserOptinAction {
    type: typeof ACTION_SET_USER_OPT_IN;
    optInType: OptInType;
    optInValue: boolean;
}

interface ClearUSerAction {
    type: typeof ACTION_CLEAR_USER_DATA;
}

export type UserActionTypes =
    | SetUserAction
    | RemoveUserAction
    | SetSyncedWalletAction
    | SetUserPrimaryYatAction
    | SetUserSkipPrimaryYatFlowAction
    | SetUserOptinsAction
    | ClearUSerAction
    | SetUserOptinAction;
